import { create } from 'zustand';
import { IIconStatus } from 'atol-atoms-2/IconStatus';

export type PopupType = 'positive' | 'negative' | 'neutral' | 'info';

type PopupOpenedState = {
    isOpen: true;
    message: string;
    title?: string
    type: IIconStatus['status'];
    duration: number;
}

type PopupClosedState = {
    isOpen: false;
    message: undefined;
    title: undefined
    type: undefined;
    duration: undefined;
}

type PopupClosedStateful = {
    queue: ShowPopupParams[];
}

type ShowPopupParams = {
    title: string;
    message?: string;
    type?: IIconStatus['status'];
    duration?: number;
}

type PopupStateSetters = {
    showPopup: (params: ShowPopupParams) => void;
    hidePopup: () => void;
}

type PopupState = (PopupOpenedState | PopupClosedState) & PopupClosedStateful & PopupStateSetters

const initialPopupStoreState: PopupClosedState = {
    isOpen: false,
    title: undefined,
    message: undefined,
    type: undefined,
    duration: undefined,
}

export const DELAY_BETWEEN_ERROR_SHOW = 400

export const usePopupStore = create<PopupState>((set, get) => ({
    ...initialPopupStoreState,
    queue: [],
    showPopup: ({ title, message, type = 'information', duration = 5000 }) => {
        const { isOpen, queue } = get()
        if (isOpen === false && queue.length === 0) {
            set({
                isOpen: true,
                duration,
                message,
                title,
                type,
            })
        } else {
            set({
                queue: [...queue, { title, message, type, duration }]
            })
        }
    },
    hidePopup: () => {
        set(initialPopupStoreState)
        setTimeout(() => {
            const { queue } = get()
            if (queue.length > 0) {
                const [params, ...rest] = queue
                const { title, message, duration, type } = params
                set({
                    queue: rest,
                    isOpen: true,
                    duration,
                    title,
                    message,
                    type,
                })
            }
        }, DELAY_BETWEEN_ERROR_SHOW)
    },
}));